import { render } from "./PainelMemoria.vue?vue&type=template&id=3d1c36ba&scoped=true"
import script from "./PainelMemoria.vue?vue&type=script&lang=js"
export * from "./PainelMemoria.vue?vue&type=script&lang=js"

import "./PainelMemoria.vue?vue&type=style&index=0&id=3d1c36ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d1c36ba"]])

export default __exports__